module.exports = __webpack_public_path__ + "img/2_1_1.45139d4e.jpg";